import React, { useEffect } from 'react';
import { object, string, func } from 'prop-types';
import { connect } from 'react-redux';
import { ViewTab } from '../constants';
import { fetchAllCollections } from '../../../store/collections/actions';
import Sellers from './Sellers';
import Gigs from './Gigs';
import EmptyView from './EmptyView';

import './style.scss';

const ItemView = ({ activeTab, gigsView, sellersView, fetchAllCollections }) => {
    useEffect(() => {
        fetchAllCollections();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const shouldRenderGigs = activeTab === ViewTab.GIGS && gigsView.total > 0;
    const shouldRenderSellers = activeTab === ViewTab.SELLERS && sellersView.total > 0;
    const shouldRenderEmptyView = !shouldRenderGigs && !shouldRenderSellers;

    return (
        <div className="item-view">
            {shouldRenderGigs && <Gigs />}
            {shouldRenderSellers && <Sellers />}
            {shouldRenderEmptyView && <EmptyView />}
        </div>
    );
};

ItemView.propTypes = {
    activeTab: string.isRequired,
    gigsView: object,
    sellersView: object,
    fetchAllCollections: func,
};

const mapStateToProps = ({ gigsView, sellersView }) => ({
    gigsView,
    sellersView,
});

const mapDispatchToProps = {
    fetchAllCollections,
};

export { ItemView };
export default connect(mapStateToProps, mapDispatchToProps)(ItemView);
